/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_File_Exists_ConfirmInputs */

const en_video_export_file_exists_confirm = /** @type {(inputs: Video_Export_File_Exists_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overwrite`)
};

const fr_video_export_file_exists_confirm = /** @type {(inputs: Video_Export_File_Exists_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ecraser`)
};

const de_video_export_file_exists_confirm = /** @type {(inputs: Video_Export_File_Exists_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überschreiben`)
};

const it_video_export_file_exists_confirm = /** @type {(inputs: Video_Export_File_Exists_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovrascrivi`)
};

const ru_video_export_file_exists_confirm = /** @type {(inputs: Video_Export_File_Exists_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перезаписать`)
};

const es_video_export_file_exists_confirm = /** @type {(inputs: Video_Export_File_Exists_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobrescribir`)
};

const zh_cn2_video_export_file_exists_confirm = /** @type {(inputs: Video_Export_File_Exists_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`覆盖`)
};

const ja_video_export_file_exists_confirm = /** @type {(inputs: Video_Export_File_Exists_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上書き`)
};

const hi_video_export_file_exists_confirm = /** @type {(inputs: Video_Export_File_Exists_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओवरराइट करें`)
};

const pt_pt2_video_export_file_exists_confirm = /** @type {(inputs: Video_Export_File_Exists_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Substituir`)
};

/**
* | output |
* | --- |
* | "Overwrite" |
*
* @param {Video_Export_File_Exists_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_file_exists_confirm = /** @type {((inputs?: Video_Export_File_Exists_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_File_Exists_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_file_exists_confirm(inputs)
	if (locale === "de") return de_video_export_file_exists_confirm(inputs)
	if (locale === "it") return it_video_export_file_exists_confirm(inputs)
	if (locale === "ru") return ru_video_export_file_exists_confirm(inputs)
	if (locale === "es") return es_video_export_file_exists_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_file_exists_confirm(inputs)
	if (locale === "ja") return ja_video_export_file_exists_confirm(inputs)
	if (locale === "hi") return hi_video_export_file_exists_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_file_exists_confirm(inputs)
	return en_video_export_file_exists_confirm(inputs)
});